module.exports = __webpack_public_path__ + "static/media/video-23-tt.f3d92bad.webm";